import { GET_CERTONA_ATTRIBUTES } from '../actionTypes/OrderActionTypes';

export const getCertonaAttributes = (payload) => ({
    type: GET_CERTONA_ATTRIBUTES,
    payload,
});

export default getCertonaAttributes;
